import { render } from "./PassengerList.vue?vue&type=template&id=02705762&scoped=true&lang=pug"
import script from "./PassengerList.vue?vue&type=script&lang=ts"
export * from "./PassengerList.vue?vue&type=script&lang=ts"

import "./PassengerList.vue?vue&type=style&index=0&id=02705762&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-02705762"

export default script